/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { RoutingButtonComponent } from '../routing-button/routing-button.component';
import { TooltipDirective } from '../tooltip/tooltip.directive';

@Component({
  selector: 'ods-navigation-heading',
  imports: [IconComponent, RoutingButtonComponent, TooltipDirective],
  host: { class: 'w-full flex gap-4 mb-4 items-center' },
  template: `<ods-routing-button
      [linkPath]="linkPath"
      [isRelativePath]="isRelativePath"
      variant="navigation"
      size="fit"
      [tooltip]="linkTooltip"
      tooltipAriaType="aria-label"
      [dataTestId]="dataTestId"
    >
      <ods-icon icon name="arrow-back" fill="text" size="small" />
    </ods-routing-button>
    <h1 class="heading-1">{{ heading }}</h1>`,
})
export class NavigationHeadingComponent {
  @Input() dataTestId: string;
  @Input({ required: true }) heading: string;
  @Input({ required: true }) linkPath: string;
  @Input() isRelativePath: boolean = false;
  @Input() linkTooltip: string;
}
